// filepath: vsls:/src/pages/HomePage.jsx
import React, { useRef, useState } from 'react';
import { sendToGemini, getJSONschedule } from '../api/geminiApi';
import { addCalendarEvent, addCalendarEvents } from '../api/calendarApi';
import { getDocument, GlobalWorkerOptions } from 'pdfjs-dist';
import pdfjsWorker from 'pdfjs-dist/build/pdf.worker.entry';
import ReactMarkdown from 'react-markdown';
import '../stylesheets/HomePage.css';

GlobalWorkerOptions.workerSrc = pdfjsWorker;

export default function HomePage() {
  const fileInputRef = useRef(null);
  const canvasRef = useRef(null);
  const [parsedText, setParsedText] = useState('');
  const [responseText, setResponseText] = useState('');
  const [jsonText, setJsonText] = useState('');
  const allowedTypes = ['application/pdf'];
  const [subheadingText, setSubheadingText] = useState('Please begin by uploading your course outline.');

  const handleClick = () => {
    fileInputRef.current.click();
  };

  const handleFileChange = async (e) => {
    const file = e.target.files[0];

    if (!allowedTypes.includes(file.type)) {
      alert("File type not allowed");
      e.target.value = '';
      return;
    }

    const reader = new FileReader();

    reader.onload = async () => {
      try {
        const pdfData = new Uint8Array(reader.result);
        const pdf = await getDocument({ data: pdfData }).promise;

        let parsedText = '';
        for (let i = 1; i <= pdf.numPages; i++) {
          const page = await pdf.getPage(i);
          const content = await page.getTextContent();
          const pageText = content.items.map(item => item.str).join(' ');
          parsedText += pageText + '\n';

          if (i === 1 && canvasRef.current) {
            const viewport = page.getViewport({ scale: 1.5 });
            const canvas = canvasRef.current;
            const context = canvas.getContext('2d');
            canvas.height = viewport.height;
            canvas.width = viewport.width;

            const renderContext = {
              canvasContext: context,
              viewport: viewport,
            };
            await page.render(renderContext).promise;
          }
        }
        const geminiReply = await sendToGemini(parsedText);
        setResponseText(geminiReply);
        setSubheadingText('Want to add another course to your schedule? Change file below!');
        setParsedText(parsedText);
        const jsonText = await getJSONschedule(geminiReply);
        setJsonText(jsonText);
        const match = jsonText.match(/{[\s\S]*}/); 
        const cleaned = match ? match[0] : jsonText;
        const json = JSON.parse(cleaned);
        console.log(json);        
        try {
          if (json.events && Array.isArray(json.events)) {
            await addCalendarEvents(json.events);
          } else {
            alert("Failed to parse events. Please check the JSON format.");
          }
        } catch (err) {
          console.error("Failed to add event:", err);
        }
      } catch (error) {
        console.error("Error parsing PDF:", error);
        alert("Failed to parse the PDF file.");
      }
    };

    reader.onerror = () => {
      console.error("Error reading file");
      alert("Failed to read the file.");
    };

    reader.readAsArrayBuffer(file);
  };

  return (
    <div className="container">
      <div className="logo-box">
        <img className="logo" src="/assets/coursepilot-logo.png" alt="Course Pilot" />
        <h1 className="logo-text">COURSE PILOT</h1>
      </div>

      <p className="subheading">{subheadingText}</p>

      <div className="content-row">

        <div className="file-box">
          <canvas
            ref={canvasRef}
            className="pdf-preview-canvas"
            style={{ display: parsedText ? 'block' : 'none' }}
          />
          <img className="upload-icon" src="/assets/upload-icon.png" alt="Upload Icon" style={{ display: parsedText ? 'none' : 'block' }} />
          <p className="upload-text" style={{ display: parsedText ? 'none' : 'block' }}>Select a file</p>
          <button onClick={handleClick} className="upload-button">{parsedText ? 'Change File' : 'Upload'}</button>
          <input
            type="file"
            ref={fileInputRef}
            onChange={handleFileChange}
            accept=".pdf"
            style={{ display: 'none' }}
          />
        </div>

        {responseText && (
          <div className="parsed-text">
            <h2>Course Pilot Response:</h2>
            <ReactMarkdown>{responseText}</ReactMarkdown>
          </div>
        )}
      </div>
    </div>
  );
}
